import React, { useState } from 'react';

export function PlaceholderScreen({ title, icon, description, onBack }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">{title}</h1>
      </div>
      <div className="flex flex-col items-center justify-center p-8 mt-20">
        <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mb-6">
          <span className="text-5xl">{icon}</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
        <p className="text-gray-500 text-center">{description}</p>
        <button onClick={onBack} className="mt-6 px-6 py-3 bg-primary text-white rounded-full font-semibold">Go Back Home</button>
      </div>
    </div>
  );
}

export function MyProfileScreen({ onBack }) {
  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-gradient-to-r from-primary to-orange-500 p-4 pb-20">
        <div className="flex items-center gap-4">
          <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#ffffff', padding: '4px' }}>&lt;</button>
          <h1 className="text-xl font-bold text-white">My Profile</h1>
        </div>
      </div>
      <div className="px-4 -mt-12">
        <div className="bg-white rounded-xl p-6 shadow-sm text-center">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl">👤</span>
          </div>
          <h2 className="text-xl font-bold">Highway Traveler</h2>
          <p className="text-gray-500">+91 98765 43210</p>
          <button className="mt-4 text-primary font-semibold text-sm">Edit Profile</button>
        </div>
        <div className="mt-4 bg-white rounded-xl p-4 shadow-sm">
          <h3 className="font-bold text-gray-900 mb-3">Account Settings</h3>
          {[
            { icon: '📧', label: 'Email', value: 'traveler@email.com' },
            { icon: '🚗', label: 'Default Vehicle', value: 'DL 01 AB 1234' },
            { icon: '🏠', label: 'Home Address', value: 'New Delhi, India' },
            { icon: '🔔', label: 'Notifications', value: 'Enabled' },
          ].map((item) => (
            <div key={item.label} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
              <div className="flex items-center gap-3"><span>{item.icon}</span><span className="text-gray-600">{item.label}</span></div>
              <span className="text-gray-900 font-medium">{item.value}</span>
            </div>
          ))}
        </div>
        <button className="w-full mt-4 py-3 border border-red-500 text-red-500 rounded-xl font-semibold">Logout</button>
      </div>
    </div>
  );
}

export function MyTripsScreen({ onBack }) {
  const trips = [
    { id: 1, from: 'Delhi', to: 'Jaipur', date: '15 Feb 2025', status: 'Upcoming', distance: '280 km' },
    { id: 2, from: 'Mumbai', to: 'Pune', date: '10 Feb 2025', status: 'Completed', distance: '150 km' },
    { id: 3, from: 'Delhi', to: 'Agra', date: '5 Feb 2025', status: 'Completed', distance: '230 km' },
  ];
  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">My Trips</h1>
      </div>
      <div className="p-4">
        {trips.map((trip) => (
          <div key={trip.id} className="bg-white rounded-xl p-4 shadow-sm mb-3">
            <div className="flex items-center justify-between mb-2">
              <span className={`px-2 py-1 rounded text-xs font-bold ${trip.status === 'Upcoming' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{trip.status}</span>
              <span className="text-sm text-gray-500">{trip.date}</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <div className="w-0.5 h-8 bg-gray-300"></div>
                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              </div>
              <div className="flex-1">
                <p className="font-semibold">{trip.from}</p>
                <p className="text-xs text-gray-400 my-1">{trip.distance}</p>
                <p className="font-semibold">{trip.to}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MyOrdersScreen({ onBack, initialOrderId = null }) {
  const [orders, setOrders] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedOrder, setSelectedOrder] = React.useState(null);
  const [orderDetail, setOrderDetail] = React.useState(null);
  const [detailLoading, setDetailLoading] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(null);
  const [dhabaImage, setDhabaImage] = React.useState(null);
  const [lastUpdated, setLastUpdated] = React.useState(null);
  const [nowTick, setNowTick] = React.useState(Date.now());
  const autoOpenedRef = React.useRef(false);

  const API_BASE = process.env.REACT_APP_BACKEND_URL;
  const ACTIVE_STATUSES = ['placed', 'confirmed', 'preparing', 'ready'];

  // Fetch orders list (with silent flag for polling)
  const fetchOrders = React.useCallback(async (silent = false) => {
    const token = localStorage.getItem('hiway_token');
    if (!token) { setLoading(false); return; }
    if (!silent) setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/orders/my-orders`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setOrders(data.orders || []);
      setLastUpdated(Date.now());
    } catch { /* silent */ }
    if (!silent) setLoading(false);
  }, [API_BASE]);

  // Initial load
  React.useEffect(() => { fetchOrders(false); }, [fetchOrders]);

  // Poll list every 15s while any active order exists, stop otherwise
  React.useEffect(() => {
    if (selectedOrder) return; // don't poll list while on detail
    const hasActive = orders.some(o => ACTIVE_STATUSES.includes(o.status));
    if (!hasActive) return;
    const id = setInterval(() => fetchOrders(true), 15000);
    return () => clearInterval(id);
  }, [orders, selectedOrder, fetchOrders]); // eslint-disable-line react-hooks/exhaustive-deps

  // Tick every 30s to refresh "X min ago" display
  React.useEffect(() => {
    const id = setInterval(() => setNowTick(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);

  // Refresh detail (silent polling flag)
  const fetchOrderDetail = React.useCallback(async (orderId, silent = false) => {
    try {
      const token = localStorage.getItem('hiway_token');
      const res = await fetch(`${API_BASE}/api/orders/${orderId}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) {
        setOrderDetail(data.order);
        setLastUpdated(Date.now());
        return data.order;
      }
    } catch { /* silent */ }
    return null;
  }, [API_BASE]);

  const loadOrderDetail = async (orderId) => {
    setDetailLoading(true);
    setDhabaImage(null);
    const order = await fetchOrderDetail(orderId, false);
    if (order) {
      setSelectedOrder(orderId);
      // Fetch dhaba image (one-shot)
      fetch(`${API_BASE}/api/v1/dhabas/${order.dhaba_id}`)
        .then(r => r.json())
        .then(d => {
          if (d.success && d.dhaba) {
            const photos = d.dhaba.photos || {};
            const ext = (photos.exterior || [])[0] || (photos.dining || [])[0];
            setDhabaImage(ext || d.dhaba.image || null);
          }
        }).catch(() => {});
    }
    setDetailLoading(false);
  };

  // Auto-open detail if initialOrderId prop is provided (from Home screen deep-link)
  React.useEffect(() => {
    if (initialOrderId && !autoOpenedRef.current) {
      autoOpenedRef.current = true;
      loadOrderDetail(initialOrderId);
    }
  }, [initialOrderId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Poll detail every 10s while order is active
  React.useEffect(() => {
    if (!selectedOrder || !orderDetail) return;
    if (!ACTIVE_STATUSES.includes(orderDetail.status)) return;
    const id = setInterval(() => fetchOrderDetail(selectedOrder, true), 10000);
    return () => clearInterval(id);
  }, [selectedOrder, orderDetail, fetchOrderDetail]); // eslint-disable-line react-hooks/exhaustive-deps

  const statusStyle = {
    placed: { bg: '#FEF3C7', color: '#92400E', label: 'Placed' },
    confirmed: { bg: '#DBEAFE', color: '#1E40AF', label: 'Confirmed' },
    preparing: { bg: '#EDE9FE', color: '#6D28D9', label: 'Preparing' },
    ready: { bg: '#D1FAE5', color: '#065F46', label: 'Ready for Pickup' },
    picked_up: { bg: '#F3F4F6', color: '#374151', label: 'Picked Up' },
    cancelled: { bg: '#FEE2E2', color: '#991B1B', label: 'Cancelled' },
  };

  // Helpers
  const formatRelative = (ts) => {
    if (!ts) return '';
    const diff = Math.round((nowTick - ts) / 1000);
    if (diff < 5) return 'just now';
    if (diff < 60) return `${diff}s ago`;
    const mins = Math.floor(diff / 60);
    if (mins < 60) return `${mins} min ago`;
    const hrs = Math.floor(mins / 60);
    return `${hrs}h ago`;
  };

  const StepTracker = ({ status, size = 'normal' }) => {
    const STEPS = [
      { key: 'placed', label: 'Placed', icon: '📝' },
      { key: 'confirmed', label: 'Confirmed', icon: '✓' },
      { key: 'preparing', label: 'Preparing', icon: '🍳' },
      { key: 'ready', label: 'Ready', icon: '🛎️' },
    ];
    const currentIdx = STEPS.findIndex(s => s.key === status);
    const isCompact = size === 'compact';
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '10px', padding: isCompact ? '0' : '4px 0' }}>
        {STEPS.map((step, idx) => {
          const isDone = idx < currentIdx;
          const isCurrent = idx === currentIdx;
          const isFuture = idx > currentIdx;
          return (
            <React.Fragment key={step.key}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                <div style={{
                  width: isCompact ? '22px' : '28px',
                  height: isCompact ? '22px' : '28px',
                  borderRadius: '50%',
                  background: isDone ? '#22C55E' : isCurrent ? '#D4AF37' : '#E5E7EB',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: isFuture ? '#9CA3AF' : '#FFF',
                  fontSize: isCompact ? '11px' : '13px',
                  fontWeight: '700',
                  boxShadow: isCurrent ? '0 0 0 4px rgba(212,175,55,0.25)' : 'none',
                  animation: isCurrent ? 'ht-pulse 1.5s ease-in-out infinite' : 'none',
                  transition: 'all 0.3s ease',
                  zIndex: 2,
                }}
                data-testid={`tracker-step-${step.key}`}>
                  {isDone ? '✓' : (isCompact ? '' : step.icon)}
                </div>
                {!isCompact && (
                  <span style={{
                    fontSize: '10px',
                    color: isDone || isCurrent ? '#1A1A1A' : '#9CA3AF',
                    fontWeight: isCurrent ? '700' : '500',
                    marginTop: '4px',
                    textAlign: 'center',
                  }}>{step.label}</span>
                )}
              </div>
              {idx < STEPS.length - 1 && (
                <div style={{
                  flex: 1,
                  height: '3px',
                  background: idx < currentIdx ? '#22C55E' : '#E5E7EB',
                  marginTop: isCompact ? '10px' : '12px',
                  transition: 'background 0.3s ease',
                }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  // Order Detail Page
  if (selectedOrder && orderDetail) {
    const s = statusStyle[orderDetail.status] || statusStyle.placed;
    const itemTotal = orderDetail.item_total || (orderDetail.items || []).reduce((sum, i) => sum + (i.price * i.quantity), 0);
    const gst = orderDetail.gst_amount || Math.round(itemTotal * 0.05 * 100) / 100;
    const platformFee = orderDetail.platform_fee || 5;
    const total = orderDetail.total_amount || (itemTotal + gst + platformFee);
    const isActive = ACTIVE_STATUSES.includes(orderDetail.status);
    const isReady = orderDetail.status === 'ready';

    return (
      <div style={{ minHeight: '100vh', background: '#F9FAFB', paddingBottom: '24px' }}>
        <style>{`
          @keyframes ht-pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.15); } }
          @keyframes ht-banner-pulse { 0%,100% { box-shadow: 0 4px 20px rgba(34,197,94,0.4); } 50% { box-shadow: 0 4px 30px rgba(34,197,94,0.7); } }
        `}</style>
        <div style={{ background: 'linear-gradient(180deg, #1A1A1A, #2D2D2D)', padding: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button onClick={() => { setSelectedOrder(null); setOrderDetail(null); }}
                data-testid="back-to-orders"
                style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.2)', color: '#D4AF37', fontSize: '18px', cursor: 'pointer' }}>←</button>
              <h1 style={{ fontSize: '18px', fontWeight: '700', color: '#D4AF37', fontFamily: "'Manrope', sans-serif" }}>Order Details</h1>
            </div>
            {isActive && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', animation: 'ht-pulse 1.5s ease-in-out infinite' }} />
                <span style={{ fontSize: '11px', color: '#22C55E', fontWeight: '600' }}>LIVE</span>
              </div>
            )}
          </div>
        </div>

        <div style={{ padding: '16px' }}>
          {/* Ready-for-pickup prominent banner */}
          {isReady && (
            <div data-testid="ready-banner" style={{
              background: 'linear-gradient(135deg, #22C55E, #16A34A)',
              color: '#FFF',
              borderRadius: '14px',
              padding: '16px',
              marginBottom: '12px',
              textAlign: 'center',
              animation: 'ht-banner-pulse 2s ease-in-out infinite',
            }}>
              <p style={{ fontSize: '22px', marginBottom: '4px' }}>🛎️</p>
              <p style={{ fontSize: '16px', fontWeight: '700', marginBottom: '2px' }}>Your food is ready for pickup!</p>
              <p style={{ fontSize: '12px', opacity: 0.9 }}>Head to {orderDetail.dhaba_name} now</p>
            </div>
          )}

          {/* Dhaba Info */}
          <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            {dhabaImage ? (
              <img src={dhabaImage} alt="" style={{ width: '50px', height: '50px', borderRadius: '12px', objectFit: 'cover' }} />
            ) : (
              <div style={{ width: '50px', height: '50px', borderRadius: '12px', background: 'linear-gradient(135deg, #1A1A1A, #2D2D2D)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>🍽️</div>
            )}
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '16px', fontWeight: '700', color: '#1A1A1A' }}>{orderDetail.dhaba_name}</p>
              <span style={{ padding: '3px 10px', borderRadius: '8px', background: s.bg, color: s.color, fontSize: '11px', fontWeight: '700' }}>{s.label}</span>
            </div>
            <a href={`tel:+919876543210`} style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#22C55E', display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', fontSize: '18px' }}>📞</a>
          </div>

          {/* Live Step Tracker */}
          {orderDetail.status !== 'cancelled' && (
            <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <p style={{ fontSize: '13px', fontWeight: '700', color: '#1A1A1A' }}>Order Progress</p>
                {lastUpdated && <p style={{ fontSize: '10px', color: '#9CA3AF' }}>Updated {formatRelative(lastUpdated)}</p>}
              </div>
              <StepTracker status={orderDetail.status} />
            </div>
          )}

          {/* Order ID + ETA */}
          <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontSize: '12px', color: '#9CA3AF' }}>Order ID</span>
              <span style={{ fontSize: '12px', color: '#374151', fontFamily: 'monospace' }}>{orderDetail.display_id || orderDetail.id.slice(0, 8).toUpperCase()}</span>
            </div>
            {orderDetail.eta_minutes && (
              <div style={{ display: 'flex', gap: '16px' }}>
                <div>
                  <p style={{ fontSize: '11px', color: '#9CA3AF' }}>ETA</p>
                  <p style={{ fontSize: '15px', fontWeight: '700', color: '#D4AF37' }}>{orderDetail.eta_minutes} min</p>
                </div>
                <div>
                  <p style={{ fontSize: '11px', color: '#9CA3AF' }}>Prep Time</p>
                  <p style={{ fontSize: '15px', fontWeight: '700', color: '#374151' }}>{orderDetail.max_prep_mins} min</p>
                </div>
              </div>
            )}
          </div>

          {/* Ordered Items */}
          <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px' }}>
            <p style={{ fontSize: '14px', fontWeight: '700', color: '#1A1A1A', marginBottom: '12px' }}>Ordered Items</p>
            {(orderDetail.items || []).map((item, idx) => (
              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: idx < orderDetail.items.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ width: '12px', height: '12px', border: `2px solid ${item.is_veg ? '#22C55E' : '#EF4444'}`, borderRadius: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: item.is_veg ? '#22C55E' : '#EF4444' }} />
                  </span>
                  <div>
                    <p style={{ fontSize: '14px', color: '#1A1A1A' }}>{item.name}</p>
                    <p style={{ fontSize: '12px', color: '#9CA3AF' }}>x{item.quantity} • Prep ~{item.prep_time_mins || 15} min</p>
                  </div>
                </div>
                <p style={{ fontSize: '14px', fontWeight: '600', color: '#1A1A1A' }}>₹{item.price * item.quantity}</p>
              </div>
            ))}
            {orderDetail.special_instructions && (
              <div style={{ marginTop: '10px', padding: '8px 10px', background: '#FFFBEB', borderRadius: '8px', border: '1px solid #FDE68A' }}>
                <p style={{ fontSize: '11px', color: '#92400E' }}>Note: {orderDetail.special_instructions}</p>
              </div>
            )}
          </div>

          {/* Bill Summary */}
          <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px' }}>
            <p style={{ fontSize: '14px', fontWeight: '700', color: '#1A1A1A', marginBottom: '12px' }}>Bill Summary</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Item Total</span>
              <span style={{ fontSize: '13px', color: '#1A1A1A' }}>₹{itemTotal.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>GST & Dhaba Charges</span>
              <span style={{ fontSize: '13px', color: '#1A1A1A' }}>₹{gst.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Delivery Partner Fee</span>
              <span style={{ fontSize: '13px', color: '#22C55E' }}>FREE</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Platform Fee (incl. GST)</span>
              <span style={{ fontSize: '13px', color: '#1A1A1A' }}>₹{platformFee.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: '2px solid #1A1A1A', marginTop: '8px' }}>
              <span style={{ fontSize: '15px', fontWeight: '700', color: '#1A1A1A' }}>Paid</span>
              <span style={{ fontSize: '15px', fontWeight: '700', color: '#1A1A1A' }}>₹{total.toFixed(2)}</span>
            </div>
          </div>

          {/* Payment & Delivery */}
          <div style={{ background: '#FFF', borderRadius: '14px', padding: '16px', marginBottom: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F3F4F6' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Payment Method</span>
              <span style={{ fontSize: '13px', fontWeight: '600', color: '#1A1A1A' }}>Pay at Counter</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F3F4F6' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Payment Date</span>
              <span style={{ fontSize: '13px', color: '#1A1A1A' }}>{orderDetail.placed_at ? new Date(orderDetail.placed_at).toLocaleDateString() : '—'}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
              <span style={{ fontSize: '13px', color: '#6B7280' }}>Pickup At</span>
              <span style={{ fontSize: '13px', color: '#1A1A1A' }}>{orderDetail.dhaba_name}</span>
            </div>
          </div>

          {/* Download Invoice PDF */}
          <button onClick={async () => {
            try {
              const token = localStorage.getItem('hiway_token');
              const res = await fetch(`${API_BASE}/api/orders/${orderDetail.id}/invoice`, { headers: { Authorization: `Bearer ${token}` } });
              if (res.ok) {
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url; a.download = `${orderDetail.display_id || 'HT-Invoice'}.pdf`;
                a.click(); URL.revokeObjectURL(url);
              }
            } catch (e) { /* silent */ }
          }}
            style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '2px solid #1A1A1A', background: '#FFF', color: '#1A1A1A', fontWeight: '700', fontSize: '15px', cursor: 'pointer' }}>
            Download Invoice (PDF)
          </button>
        </div>
      </div>
    );
  }

  // Orders List
  const anyActive = orders.some(o => ACTIVE_STATUSES.includes(o.status));
  return (
    <div style={{ minHeight: '100vh', background: '#F9FAFB', paddingBottom: '24px' }}>
      <style>{`
        @keyframes ht-pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.15); } }
        @keyframes ht-ready-glow { 0%,100% { box-shadow: 0 0 0 2px #22C55E, 0 4px 14px rgba(34,197,94,0.3); } 50% { box-shadow: 0 0 0 2px #22C55E, 0 6px 22px rgba(34,197,94,0.55); } }
      `}</style>
      <div style={{ background: 'linear-gradient(180deg, #1A1A1A, #2D2D2D)', padding: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button onClick={onBack} style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.2)', color: '#D4AF37', fontSize: '18px', cursor: 'pointer' }}>←</button>
            <h1 style={{ fontSize: '18px', fontWeight: '700', color: '#D4AF37', fontFamily: "'Manrope', sans-serif" }}>My Orders</h1>
          </div>
          {anyActive && (
            <div data-testid="live-indicator" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', animation: 'ht-pulse 1.5s ease-in-out infinite' }} />
              <span style={{ fontSize: '11px', color: '#22C55E', fontWeight: '600' }}>LIVE</span>
            </div>
          )}
        </div>
        {anyActive && lastUpdated && (
          <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.5)', marginTop: '6px', marginLeft: '52px' }}>
            Updated {formatRelative(lastUpdated)}
          </p>
        )}
      </div>
      <div style={{ padding: '16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}><p style={{ color: '#6B7280' }}>Loading...</p></div>
        ) : orders.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <span style={{ fontSize: '48px', display: 'block', marginBottom: '12px' }}>📦</span>
            <p style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>No orders yet</p>
            <p style={{ fontSize: '13px', color: '#6B7280' }}>Your pre-orders will appear here</p>
          </div>
        ) : orders.map(order => {
          const s = statusStyle[order.status] || statusStyle.placed;
          const isActive = ACTIVE_STATUSES.includes(order.status);
          const isReady = order.status === 'ready';
          return (
            <div key={order.id}
              data-testid={`order-card-${order.id}`}
              style={{
                background: '#FFF',
                borderRadius: '14px',
                padding: '16px',
                marginBottom: '12px',
                border: isReady ? '2px solid #22C55E' : isActive ? '2px solid #D4AF37' : '1px solid #E5E7EB',
                position: 'relative',
                animation: isReady ? 'ht-ready-glow 2s ease-in-out infinite' : 'none',
                transition: 'all 0.3s ease',
              }}>
              {/* Three-dot menu */}
              <button onClick={(e) => { e.stopPropagation(); setMenuOpen(menuOpen === order.id ? null : order.id); }}
                style={{ position: 'absolute', top: '12px', right: '12px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#9CA3AF', padding: '4px' }}>
                ⋮
              </button>
              {menuOpen === order.id && (
                <div onClick={() => setMenuOpen(null)} style={{ position: 'absolute', top: '36px', right: '12px', background: '#FFF', borderRadius: '10px', boxShadow: '0 4px 16px rgba(0,0,0,0.15)', zIndex: 10, overflow: 'hidden', minWidth: '150px' }}>
                  <button onClick={() => { setMenuOpen(null); loadOrderDetail(order.id); }}
                    style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', borderBottom: '1px solid #F3F4F6', cursor: 'pointer', textAlign: 'left', fontSize: '13px', color: '#374151', fontWeight: '500' }}>
                    Order Details
                  </button>
                  <button onClick={() => { setMenuOpen(null); }}
                    style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontSize: '13px', color: '#374151', fontWeight: '500' }}>
                    Help & Support
                  </button>
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', paddingRight: '24px' }}>
                <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#1A1A1A' }}>{order.dhaba_name}</h3>
                <span style={{ padding: '4px 10px', borderRadius: '8px', background: s.bg, color: s.color, fontSize: '11px', fontWeight: '700' }}>{s.label}</span>
              </div>

              {isReady && (
                <div style={{ background: '#DCFCE7', color: '#065F46', padding: '6px 10px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={{ fontSize: '14px' }}>🛎️</span> Ready! Head to the dhaba now
                </div>
              )}

              <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '8px' }}>
                {order.item_count} item{order.item_count !== 1 ? 's' : ''} • ₹{order.total_amount}
              </p>
              {isActive && order.eta_minutes && (
                <div style={{ display: 'flex', gap: '12px', padding: '8px 12px', background: '#F9FAFB', borderRadius: '8px', marginBottom: '8px' }}>
                  <span style={{ fontSize: '12px', color: '#D4AF37', fontWeight: '600' }}>ETA: {order.eta_minutes} min</span>
                  {order.max_prep_mins && <span style={{ fontSize: '12px', color: '#6B7280' }}>Prep: {order.max_prep_mins} min</span>}
                </div>
              )}
              {isActive && (
                <div style={{ marginTop: '8px', marginBottom: '4px' }}>
                  <StepTracker status={order.status} size="compact" />
                </div>
              )}
              <p style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '8px' }}>
                {order.placed_at ? new Date(order.placed_at).toLocaleString() : ''}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function EmergencyScreen({ onBack }) {
  const emergencyContacts = [
    { icon: '🚔', name: 'Police', number: '100', color: 'bg-blue-100' },
    { icon: '🚑', name: 'Ambulance', number: '108', color: 'bg-red-100' },
    { icon: '🚒', name: 'Fire', number: '101', color: 'bg-orange-100' },
    { icon: '🛣️', name: 'Highway Helpline', number: '1033', color: 'bg-green-100' },
    { icon: '🚗', name: 'Roadside Assistance', number: '1800-XXX-XXXX', color: 'bg-purple-100' },
  ];
  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-red-500 p-4 pb-6">
        <div className="flex items-center gap-4">
          <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#ffffff', padding: '4px' }}>&lt;</button>
          <h1 className="text-xl font-bold text-white">Emergency</h1>
        </div>
        <p className="text-white/80 mt-2 text-sm">Quick access to emergency services</p>
      </div>
      <div className="p-4">
        <div className="bg-white rounded-xl p-4 shadow-sm mb-4">
          <h3 className="font-bold text-gray-900 mb-1">Your Location</h3>
          <p className="text-sm text-gray-500 flex items-center gap-1"><span>📍</span> NH-48, Near Manesar Toll Plaza</p>
        </div>
        {emergencyContacts.map((contact) => (
          <a key={contact.name} href={`tel:${contact.number}`} className="bg-white rounded-xl p-4 shadow-sm mb-3 flex items-center gap-4 block">
            <div className={`w-14 h-14 ${contact.color} rounded-xl flex items-center justify-center`}><span className="text-2xl">{contact.icon}</span></div>
            <div className="flex-1"><h3 className="font-bold text-gray-900">{contact.name}</h3><p className="text-primary font-semibold">{contact.number}</p></div>
            <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center"><span className="text-white">📞</span></div>
          </a>
        ))}
        <div className="mt-6 bg-yellow-50 rounded-xl p-4">
          <h3 className="font-bold text-yellow-800 flex items-center gap-2"><span>⚠️</span> Safety Tips</h3>
          <ul className="mt-2 text-sm text-yellow-700 space-y-1">
            <li>Stay calm and assess the situation</li>
            <li>Move to a safe location if possible</li>
            <li>Share your live location with family</li>
            <li>Keep emergency contacts saved offline</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
